import {
  DeleteOutlined, DownloadOutlined, InboxOutlined, LoadingOutlined,
} from '@ant-design/icons';
import {
  Alert,
  Button,
  Card, Col, DatePicker, Form, Modal, notification, Popconfirm, Row, Spin,
} from 'antd';
import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import Dragger from 'antd/lib/upload/Dragger';
import getUserRole from '../../../../utils/localeStorage/getUserRole';
import { updateCoexecutorStep, uploadFile } from '../../../../utils/http';


const templates = [
  {
    name: 'Требования к оформлению отчета ГОСТ 7 32 2017',
    urlLink: '/coexecutors25/Требования_к_оформлению_отчета_ГОСТ_7_32_2017.docx',
  },
  {
    name: 'Шаблон отчета ГОСТ',
    urlLink: '/coexecutors25/Шаблон_отчета_ГОСТ.docx',
  },
];

export const NirReport = ({ stepData, stepId, onRefetchData }) => {
  const [opened, setOpened] = useState(false);
  const [loading, setLoading] = useState(false);

  const [files, setFiles] = useState(stepData.nirReports || []);

  const handleSave = async () => {
    setLoading(true);

    const filesToUpload = [];

    // Перебираем файлы
    // eslint-disable-next-line no-restricted-syntax
    for (const file of files) {
      if (file.urlLink) {
        // Есть урл - загружен - скипаем
        // eslint-disable-next-line no-continue
        continue;
      }

      const form = new FormData();
      const headers = {
        'Content-Type': 'multipart/form-data',
      };
      form.append('file', file.originFileObj);
      const uploadedFile = uploadFile(form, headers);

      filesToUpload.push(uploadedFile);
    }

    // Ждем загрузки
    const uploadedFiles = await Promise.all(filesToUpload);

    const jsonDataClone = structuredClone(stepData);

    const oldFiles = files.filter((f) => f.urlLink);
    jsonDataClone.nirReports = [...oldFiles, ...uploadedFiles];

    try {
      const resp = await updateCoexecutorStep({ id: stepId, stepJSON: JSON.stringify(jsonDataClone) });
      if (resp.status !== 'OK') {
        notification.error({ message: 'Произошла ошибка. Попробуйте еще раз' });
        setLoading(false);
        return;
      }
      notification.success({ message: 'Сохранено' });
    } catch (e) {
      notification.error({ message: 'Произошла ошибка. Попробуйте еще раз' });
    }

    setLoading(false);
    onRefetchData();
  };

  const handleReportFileRemove = (name) => {
    const newFiles = files.filter((f) => f.name !== name);
    setFiles(newFiles);
  };

  useEffect(() => {
    setFiles(stepData.nirReports || []);
  }, [stepData]);

  return (
    <Card
      style={{ width: '100%', borderRadius: '15px', marginTop: '20px' }}
    >
      <Row justify="space-between" align="middle">
        <Col style={{ fontSize: '20px', color: '#212121' }}>Отчет о НИР по ГОСТ 7.32-2017</Col>
        <Col style={{ cursor: 'pointer' }}>
          {opened && (<Button type="primary" disabled={loading} style={{ marginRight: '10px' }} onClick={handleSave}>Сохранить</Button>)}
          <Button disabled={loading} type={opened ? 'default' : 'primary'} onClick={() => setOpened(!opened)}>{opened ? 'Закрыть' : 'Развернуть'}</Button>
        </Col>
      </Row>
      <Alert
        type="warning"
        style={{ margin: '10px 0px' }}
        description="Ниже представлены вспомогательные документы для подготовки отчета, соответствующего общим требованиям к структуре и правилам оформления, установленным «ГОСТ 7.32-2017. Межгосударственный стандарт. Система стандартов по информации, библиотечному и издательскому делу. Отчет о научно-исследовательской работе. Структура и правила оформления»."
      />
      {opened && (
        <Col span={24} style={{ paddingTop: '20px' }}>
          {templates.map((f) => (
            <Row key={f.id} style={{ margin: '5px 0px' }} gutter={12}>
              <Col><Button type="primary" onClick={() => window.open(f.urlLink)}>Скачать</Button></Col>
              <Col style={{ color: '#212121', fontSize: '20px' }}>{f.name}</Col>
            </Row>
          ))}
          <Row style={{ fontSize: '18px', color: '#212121', marginTop: '20px' }}>Файлы отчета</Row>
          <Dragger
            showUploadList={false}
            onChange={(e) => setFiles(e.fileList)}
            fileList={files}
            multiple
            action={null}
          >
            <p className="ant-upload-drag-icon">
              <InboxOutlined />
            </p>
            <p className="ant-upload-text">Выберите или перенесите файлы, чтобы загрузить</p>
          </Dragger>
          {files.map((f) => (
            <Row key={f.name} style={{ margin: '5px 0px' }} gutter={12}>
              {f.urlLink && <Col><Button type="primary" onClick={() => window.open(f.urlLink)}>Скачать</Button></Col>}
              <Col>
                <Popconfirm
                  title="Вы уверены, что хотите удалить файл?"
                  onConfirm={() => handleReportFileRemove(f.name)}
                  okText="Да"
                  cancelText="Нет"
                >
                  <Button>Удалить</Button>
                </Popconfirm>
              </Col>
              <Col style={{ color: '#212121', fontSize: '20px' }}>{f.name}</Col>
            </Row>
          ))}
        </Col>
      )}
    </Card>
  );
};

NirReport.propTypes = {
  stepId: PropTypes.string.isRequired,
  stepData: PropTypes.shape().isRequired,
  onRefetchData: PropTypes.func.isRequired,
};
